import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

/**
 * SubscriptionGuard
 * - ถ้า user_subscriptions.start_date = null → ยังไม่มี plan → redirect ไป /subscription-payment
 * - ถ้ามี start_date แล้ว → ผ่าน
 */
const SubscriptionGuard = ({ children }) => {
  const [status, setStatus] = useState('checking');

  useEffect(() => {
    const check = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) {
          setStatus('no-sub');
          return;
        }

        const { data } = await supabase
          .from('user_subscriptions')
          .select('start_date')
          .eq('user_id', user.id)
          .maybeSingle();

        if (!data || !data.start_date) {
          setStatus('no-sub');
        } else {
          setStatus('ok');
        }
      } catch {
        setStatus('no-sub');
      }
    };

    check();
  }, []);

  if (status === 'checking') return null;
  if (status === 'no-sub') return <Navigate to="/subscription-payment" replace />;

  return children;
};

export default SubscriptionGuard;
